export default __webpack_public_path__ + "static/media/slide5.040ca1e8.webp";